import addresses from '../data/addresses/addresses.json';

type AddressType = {
  id: string,
  type: string,
  address1: string,
  address2: string,
  city: string,
  state: string,
  zipCode: string,
}

export const formatAddressToString = ({ address1, address2, city, state, zipCode }: AddressType) => (
  [address1, address2, city, state, zipCode].filter(str => !!str).join(', ')
);

export const formatAddressInTwoLines = ({ address1, address2, city, state, zipCode }: AddressType):[string, string] => {
  const lineOne = [address1, address2].filter(str => !!str).join(', ');
  const lineTwo = `${city}, ${state} ${zipCode}`;

  return [lineOne, lineTwo];
}

export const getAllAddressesMappedByType = () => {
  return addresses.data.reduce((map: any, address: AddressType) => {
    const currentAddressMap = map[address.type] || [];
    const newMap = {
      [address.type]: [...currentAddressMap, address]
    }

    return Object.assign({}, map, newMap)
  }, {});
};

export const getAllAddresses = () => {
  return addresses;
};
